import $ from 'jquery';
window.$ = window.jQuery = require('jquery');
import '../../node_modules/js-datepicker/dist/datepicker.min';
import '../../node_modules/@fancyapps/fancybox/dist/jquery.fancybox.min.js';
import '../../node_modules/jquery-mask-plugin/dist/jquery.mask.min.js';
import '../../node_modules/jquery-validation/dist/jquery.validate';
import '../../node_modules/jquery-validation/dist/additional-methods';
import '../../node_modules/jquery-validation/dist/localization/messages_uk';

// Calculator
import './utils/calculator.js';
// Calculator
import './utils/select.js';

import './components/_all';

// main-page
import './home';
// articles-page
import './articles';
// all news page
import './all-news';
// sharing links
import './goodshare.min';
// sharing links
import './popUp';
// validation js
import './validation';
// sharing links
import './author';
// sharing links
import './specific-article';
// subscription js
import './subscription';
// faq js
import './faq';
// subs js
import './subs';
// gift js on subs page
import './gift';
//elit popup
// import './popup/elit-popup.js';
import './popup/chooseUser';
import './popup/registrationFree';

import PhoneConsultation from './forms/PhoneConsultation';
import Tests from './Tests';
import EmailSubscription from './forms/EmailSubscription';
Tests.init();
PhoneConsultation.init();
new EmailSubscription();
